import { useEffect } from 'react';

const APP_VERSION = process.env.REACT_APP_VERSION || '0.0.0';

const VERSION_URL = '/version.json';
const RELOAD_KEY_PREFIX = 'reloaded_for_';

export default function useVersionCheck(interval = 60000) {
    useEffect(() => {
        if (process.env.NODE_ENV === 'development') {
            return;
        }

        const checkVersion = async () => {
            try {
                const response = await fetch(VERSION_URL + '?t=' + Date.now(), { cache: 'no-cache' });

                if (!response.ok) {
                    return;
                }

                const data = await response.json();

                if (!data?.version) {
                    return;
                }

                if (data.version !== APP_VERSION) {
                    const reloadKey = RELOAD_KEY_PREFIX + data.version;

                    // Clean up old reload keys
                    for (let i = localStorage.length - 1; i >= 0; i--) {
                        const key = localStorage.key(i);
                        if (key?.startsWith(RELOAD_KEY_PREFIX) && key !== reloadKey) {
                            localStorage.removeItem(key);
                        }
                    }

                    if (!localStorage.getItem(reloadKey)) {
                        localStorage.setItem(reloadKey, 'true');
                        // Force browser to bypass HTTP cache for index.html,
                        // then reload so it picks up new JS/CSS references
                        fetch(window.location.href, { cache: 'no-store' })
                            .finally(() => {
                                if ('caches' in window) {
                                    caches.keys().then((names) => Promise.all(names.map((n) => caches.delete(n)))).finally(() => {
                                        window.location.reload();
                                    });
                                } else {
                                    window.location.reload();
                                }
                            });
                    }
                }
            } catch (error) {
                // Silently ignore — version.json may not exist or be unreachable
            }
        };

        checkVersion();
        const timer = setInterval(checkVersion, interval);
        return () => clearInterval(timer);
    }, [interval]);
}
